<template>
    <div class="text-sm">
        <p class="text-base text-danger font-bold mb-0">{{ trans('modules.Ai.mic_access_required') }}</p>
        <p class="mb-0">{{ trans('modules.Ai.mic_access_steps_description') }}:</p>
        <ol class="pl-8">
            <li v-for="step in getBrowserSpecificInstructions()" :key="step">{{ step }}</li>
        </ol>
        <ep-button size="sm" @click="tryAgain">{{ trans('modules.Ai.mic_try_again') }}</ep-button>
    </div>
</template>

<script>
export default {
    name: 'MissingAudioPermissionsNotice',

    data() {
        return {
            interval: null,
        };
    },

    mounted() {
        this.interval = setInterval(() => {
            this.tryAgain();
        }, 1000);
    },

    beforeUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },

    methods: {
        tryAgain() {
            this.$emit('try-again');
        },

        getBrowserSpecificInstructions() {
            const browser = this.detectBrowser();
            const instructions = {
                chrome: {
                    desktop: [
                        'Click the camera/microphone icon in the address bar',
                        'Select "Allow" for microphone access',
                        'Refresh the page'
                    ],
                    mobile: [
                        'Go to Chrome Settings',
                        'Tap Site Settings > Microphone',
                        'Find this website and allow access'
                    ]
                },
                firefox: {
                    desktop: [
                        'Click the lock icon in the address bar',
                        'Click the gear icon next to "Microphone"',
                        'Select "Allow" and refresh the page'
                    ],
                    mobile: [
                        'Tap the three dots menu',
                        'Go to Settings > Site Permissions > Microphone',
                        'Find this website and allow access'
                    ]
                },
                safari: {
                    desktop: [
                        'Click Safari > Preferences > Websites',
                        'Find Microphone in the left sidebar',
                        'Locate this website and select "Allow"'
                    ],
                    mobile: [
                        'Open iOS Settings',
                        'Scroll down to Safari > Settings for Websites',
                        'Tap Microphone and allow access'
                    ]
                }
            };

            return instructions[browser][this.isMobile() ? 'mobile' : 'desktop'] || [
                'Open your browser settings',
                'Look for Site Permissions or Privacy settings',
                'Find Microphone permissions and allow access for this site'
            ];
        },

        detectBrowser() {
            const userAgent = navigator.userAgent.toLowerCase();

            if (userAgent.includes('chrome')) return 'chrome';
            if (userAgent.includes('firefox')) return 'firefox';
            if (userAgent.includes('safari') && !userAgent.includes('chrome')) return 'safari';
            return 'other';
        },

        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
    },

}
</script>
